import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../../../firebase';
import { CLIENT_ID, SCOPES } from '../../../googleOAuth';
import youtube_red_logo from '../../../assets/images/logo/youtube-red-logo.png';
import './integrationSetting.css';

const IntegrationSetting = () => {
  const user = auth.currentUser;
  const [isConnected, setIsConnected] = useState(false);
  const [revoking, setRevoking] = useState(false);
  const [revokeFailed, setRevokeFailed] = useState(false);

  useEffect(() => {
    if (!user) return;
    return onSnapshot(doc(db, 'users', user.uid, 'contentAccess', 'youtubeAccess'), snap => {
      const { channelId, accessToken } = snap.data() || {};
      setIsConnected(!!(channelId && accessToken));
    }, () => {});
  }, [user]);

  // Google OAuth; the connectYoutube function stores the tokens and redirects back
  const handleConnectYouTube = () => {
    const connectYoutubeUrl = `${process.env.REACT_APP_FUNCTIONS_ENDPOINT}/connectYoutube`;
    window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(connectYoutubeUrl)}&scope=${encodeURIComponent(SCOPES)}&response_type=code&access_type=offline&state=${user.uid}`;
  };

  const handleRevoke = async () => {
    setRevoking(true);
    setRevokeFailed(false);
    try {
      await httpsCallable(getFunctions(), 'revokeYoutube')();
      // Drop cached channel handles (Creator Studio caches them per channel)
      Object.keys(localStorage)
        .filter(key => key.startsWith(`${user.uid}_`) && key.endsWith('_YThandle'))
        .forEach(key => localStorage.removeItem(key));
    } catch {
      setRevokeFailed(true);
    }
    setRevoking(false);
  };

  return (
    <>
      {/* Header outside the container */}
      <div className="setting-header">Integrations</div>
      
      {/* Main container for integration settings */}
      <div className="account-settings-container">
        <div className="settings-row">
          <div className="settings-label">
            <span>YouTube</span>
            <div className="settings-subtitle">
              Connect your channel to publish and auto-comment timestamps
            </div>
          </div>
          <div className="settings-field">
            <button
              className={`settings-utube-connect-button ${isConnected ? 'connected' : ''}`}
              onClick={isConnected ? undefined : handleConnectYouTube}
              style={{ cursor: isConnected ? 'default' : 'pointer' }}
            >
              <img src={youtube_red_logo} alt="" className="settings-create-connectyoutube" />
              <span>{isConnected ? 'Connected' : 'Connect'}</span>
            </button>
            {isConnected && (
              <button className="ui-setting-button" onClick={handleRevoke} disabled={revoking}>
                {revoking ? 'Disconnecting…' : revokeFailed ? 'Retry' : 'Disconnect'}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IntegrationSetting;
